import { Card, Divider } from 'antd';
import { AnalysesTitle, IconsContainer, ItemContainer, ItemTitle } from './style';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { formatDateWithoutTime } from '../../../helpers';

interface MobileAnalysesProps {
  client?: any;
}

const MobileAnalyses = ({ client }: MobileAnalysesProps) => {
  const navigate = useNavigate();
  const { user } = useSelector((state: RootState) => state.auth) as { user: any };

  const isClient = user?.role === 'Client' || user?.__typename === 'Client';
  
  const hmaData = client?.hairAndMineralAnalyses?.filter((item: any) => isClient ? item.clientViewable : (item.professionalViewable || item.clientViewable)) || [];
  const hrvData = client?.heartRateVariabilities?.filter((item: any) => isClient ? item.clientViewable : (item.professionalViewable || item.clientViewable)) || [];
  const irCombiData = client?.irCombis?.filter((item: any) => isClient ? item.clientViewable : (item.professionalViewable || item.clientViewable)) || [];
  const iodineData = client?.iodineTests?.filter((item: any) => item.clientViewable) || [];

  const professionalCode = client?.professionalCode;
  const userCode = user?.code || professionalCode;
  const routePrefix = isClient ? `/c/${userCode}` : `/p/${professionalCode}`;

  const handleItemClick = (type: string, item: any) => {
    let path = '';
    switch (type) {
      case 'hma':
        path = `${routePrefix}/hma_results/${item.id}`;
        break;
      case 'hrv':
        path = `${routePrefix}/hrv_reports/${item.id}`;
        break;
      case 'irCombi':
        path = `${routePrefix}/ir_combis/${item.id}`;
        break;
      case 'iodine':
        path = `${routePrefix}/iodine_tests/${item.id}`;
        break;
    }
    if (path) {
      navigate(path, { state: { payload: item } });
    }
  };

  const renderAnalyses = (title: string, data: any[], type: string) => {
    if (data?.length === 0) {
      return (
        <ItemContainer>
          <ItemTitle>{title}</ItemTitle>
          <p>nog niet verkrijgbaar</p>
          <Divider />
        </ItemContainer>
      );
    }

    return data?.map((item, index) => (
      <ItemContainer 
        key={`${type}-${item.id}-${index}`} 
        onClick={() => handleItemClick(type, item)}
        style={{ cursor: 'pointer' }}
      >
        <ItemTitle>{title}{' '}
          <span>(#{item.reportNumber || item.id})</span>
        </ItemTitle>
        <p>{formatDateWithoutTime(item.dateOfAnalysis || item.createdAt)}</p>
        <IconsContainer>
          <i className="material-icons-sharp">visibility</i>
          {item.attachment && <i className="material-icons-sharp">attachments</i>}
        </IconsContainer>
        <Divider />
      </ItemContainer>
    ));
  };

  return (
    <Card>
      <AnalysesTitle>
        <p>Analyses</p>
        <Divider />
      </AnalysesTitle>
      {renderAnalyses('Haar Mineraal Analyse', hmaData, 'hma')}
      {renderAnalyses('Heart Rate Variability', hrvData, 'hrv')}
      {renderAnalyses('IR Combi', irCombiData, 'irCombi')}
      {renderAnalyses('Jodium Analyse', iodineData, 'iodine')}
    </Card>
  )
}

export default MobileAnalyses;